export default "__VITE_ASSET__876e57c7__"